import React from 'react';
import PropTypes from 'prop-types';

const TruncatedTextField = ({ source, record = {}, length = 10 }) => {
  const text = record[source];
  if (!text) {
    return <span />;
  }

  if (text.length < length) {
    return <span>{text}</span>;
  }
  return <span>{text.substring(0, length - 2)}..</span>;
};

TruncatedTextField.propTypes = {
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
};

TruncatedTextField.defaultProps = {
  record: {},
};

export default TruncatedTextField;
